/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable camelcase */
// @refresh reset
import WrapperContentLastNews from '@components/Layout/WrapperContentLastNews';
import { TimeLine } from '@/types/types';
import PageNewsWithMimirDefault, { routeTypes } from '@/components/Layout/LastNews/mimir';
import PageNewsWithMimirButton from '@/components/Layout/LastNewsWithButtom/mimir';
import WrapperContent from '@/components/Layout/WrapperContent';
import RecentNewsButton from '@/components/Layout/RecentNewsButton';
import Titulo from '@/components/Layout/Title';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { getCurrentHub } from '@sentry/nextjs';
import { enableSponsoredCategories, sponsoredCategoryType } from '@/lib/sponsors';
import { SponseredCategoryHeader } from '@/components/Layout/SponsoredCategoryHeader';

interface FeaturedLastNewsProps {
  itens: TimeLine[];
  paginacao: string;
}

interface LastNewsData {
  featuredLastNewsData?: FeaturedLastNewsProps;
  rootPage: string | string[];
  textTitle: string;
  route?: string;
  routeType?: (typeof routeTypes)[number];
  initialPage?: string | string[];
  recentButton?: boolean;
  headingTag?: 'h1' | 'h2';
  noPagination?: boolean;
  sponsoredCategory?: sponsoredCategoryType;
  backgroundColor?: string;
  useLoadMoreButton?: boolean;
  hideAds?: boolean;
}

export default function FeaturedLastNews({
  featuredLastNewsData = null,
  rootPage,
  textTitle,
  initialPage,
  route,
  routeType,
  recentButton = false,
  headingTag = 'h2',
  noPagination = false,
  sponsoredCategory = undefined,
  backgroundColor = 'bg-mglGray50',
  useLoadMoreButton = false,
  hideAds = false,
}: LastNewsData) {
  const currentSpan = getCurrentHub().getScope()?.getSpan();
  const featuredLastNewsSpan = currentSpan && currentSpan.startChild({ op: 'featuredLastNews' });

  const [noItemsFound, setNoItemsFound] = useState(false);
  const router = useRouter();
  useEffect(() => {
    setNoItemsFound(false);
  }, [router]);

  const PageNewsComponent = useLoadMoreButton ? PageNewsWithMimirButton : PageNewsWithMimirDefault;

  return (
    !noItemsFound && (
      <WrapperContentLastNews backgroundColor={backgroundColor}>
        <WrapperContent backgroundColor={backgroundColor} isOnHeader>
          {enableSponsoredCategories.includes(sponsoredCategory) && <SponseredCategoryHeader sponsoredCategory={sponsoredCategory} />}
          <Titulo texto={textTitle} color="black" headingTag={headingTag} />
        </WrapperContent>
        {recentButton && <RecentNewsButton link={rootPage.toString()} />}
        <PageNewsComponent
          posts={featuredLastNewsData?.itens || []}
          paginacao={featuredLastNewsData?.paginacao || ''}
          rootPage={rootPage}
          initialPage={initialPage}
          route={route}
          routeType={routeType}
          noPagination={noPagination}
          setNoItemsFound={setNoItemsFound}
          backgroundColor={backgroundColor}
          hideAds={hideAds}
        />
        <>{featuredLastNewsSpan && featuredLastNewsSpan.finish()}</>
      </WrapperContentLastNews>
    )
  );
}
